import { render, staticRenderFns } from "./ResolutionDetails.vue?vue&type=template&id=6faeb05d"
import script from "./ResolutionDetails.vue?vue&type=script&lang=js"
export * from "./ResolutionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports